import React, { useRef } from 'react';
import { Send } from 'lucide-react';
import { Button } from '../../ui/button';
import { isMobileContainer } from '../../../utils/device';

export default function CrmChatInput({
  onSend,
  disabled = false,
  leadingActions = null,
}) {
  const [text, setText] = React.useState('');
  const [sending, setSending] = React.useState(false);
  const textareaRef = useRef(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const value = text.trim();
    if (!value || sending || disabled) return;
    setSending(true);
    const ok = await onSend(value);
    setSending(false);
    if (ok) {
      setText('');
      textareaRef.current?.focus();
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  const isMobile = isMobileContainer();

  return (
    <form
      onSubmit={handleSubmit}
      className={`px-3 pb-3 pt-1 border-t border-border flex gap-2 items-end bg-card ${isMobile ? 'pb-safe' : ''}`}
    >
      {leadingActions}
      <textarea
        ref={textareaRef}
        value={text}
        onChange={(e) => setText(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder="Type a message..."
        rows={1}
        disabled={disabled || sending}
        className="flex-1 min-h-[40px] max-h-28 resize-none rounded-xl border border-border bg-muted px-3 py-2 text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-emerald-500/40 disabled:opacity-50"
      />
      <Button
        type="submit"
        size="icon"
        disabled={disabled || sending || !text.trim()}
        className="h-10 w-10 shrink-0 rounded-full bg-emerald-600 hover:bg-emerald-700"
        aria-label="Send message"
      >
        <Send className="h-4 w-4" />
      </Button>
    </form>
  );
}
